class Recaptcha {
    private siteKey: string;
    private instance: any;

    constructor(siteKey: string, useEnterprise: boolean) {
        this.siteKey = siteKey;
        _loadRecaptcha(siteKey, useEnterprise, () => {
            const grecaptcha = useEnterprise
                ? window.grecaptcha.enterprise
                : window.grecaptcha;

            grecaptcha.ready(() => {
                this.instance = grecaptcha;
            });
        });
    }

    async getToken(action: string) {
        if (!this.instance || !this.instance.execute) {
            throw new Error('Recaptcha has not been loaded');
        }

        const token = await this.instance.execute(this.siteKey, {
            action,
        });

        return token;
    }
}

let recaptcha: Recaptcha;

export function initRecaptcha(publicKey: string, useEnterprise: boolean) {
    recaptcha = new Recaptcha(publicKey, useEnterprise);
}

export function getRecaptcha() {
    return recaptcha;
}

function _loadRecaptcha(
    siteKey: string,
    useEnterprise: boolean,
    onLoad: () => void,
) {
    const js = document.createElement('script');
    const script = useEnterprise ? 'enterprise.js' : 'api.js';

    js.src = `https://www.recaptcha.net/recaptcha/${script}?render=${siteKey}`;
    js.onload = onLoad;

    document.body.appendChild(js);
}
